
export const COMPANY_DOC_SATISFIES_KEY = 'satisfies';
export const COMPANY_DOC_TYPE_KEY = 'doctype';

export const COMPANY_DOC_SLOTS = {
  proofAddress: 'proofAddress',
  incorporation: 'incorporation',
  shareholders: 'shareholders',
  natureOfBusiness: 'natureOfBusiness',
  proofSourceOfFunds: 'proofSourceOfFunds',
};

export function toPascalCaseEnumValue(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (!raw.includes('_')) return raw;
  return raw
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
}

export function getSlotsSatisfiedBySubtype(subtype, { country } = {}) {
  const normalized = toPascalCaseEnumValue(subtype);
  if (!normalized) return [];

  const isGerman = String(country || '')
    .trim()
    .toUpperCase() === 'DE';

  switch (normalized) {
    case 'CommercialRegisterExtract':
      return isGerman
        ? [COMPANY_DOC_SLOTS.incorporation, COMPANY_DOC_SLOTS.natureOfBusiness]
        : [COMPANY_DOC_SLOTS.incorporation, COMPANY_DOC_SLOTS.shareholders, COMPANY_DOC_SLOTS.natureOfBusiness];
    case 'ArticlesOfAssociation':
      return [COMPANY_DOC_SLOTS.incorporation];
    case 'CertificateOfIncorporation':
    case 'CompanyRegistrationCertificate':
      return [COMPANY_DOC_SLOTS.incorporation];
    case 'ShareholderList':
    case 'CapTable':
    case 'BeneficialOwnershipRegister':
    case 'NotarizedShareholderList':
      return [COMPANY_DOC_SLOTS.shareholders];
    case 'BankStatement':
      return [COMPANY_DOC_SLOTS.proofAddress, COMPANY_DOC_SLOTS.proofSourceOfFunds];
    case 'UtilityBill':
    case 'GovernmentIssuedLetter':
    case 'OfficeLeaseAgreement':
    case 'TaxDocument':
      return [COMPANY_DOC_SLOTS.proofAddress];
    case 'Invoices':
    case 'CommercialContracts':
    case 'Receipts':
    case 'BillsOfLading':
      return [COMPANY_DOC_SLOTS.natureOfBusiness];
    case 'InvestmentDocuments':
    case 'AuditedFinancialStatements':
    case 'SaleOfAssets':
      return [COMPANY_DOC_SLOTS.proofSourceOfFunds];
    default:
      return [];
  }
}

export function getSatisfiedSlotsForUpload(uploadSlotKey, subtype, { country } = {}) {
  const fromSubtype = getSlotsSatisfiedBySubtype(subtype, { country });
  return Array.from(new Set([uploadSlotKey, ...fromSubtype]));
}

export function formatSatisfiesMetadata(slotKeys) {
  return (Array.isArray(slotKeys) ? slotKeys : []).filter(Boolean).join(',');
}

export function parseSatisfiesMetadata(value) {
  return String(value || '')
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
}

export function readDocumentSubtypeFromMetadata(meta = {}) {
  const candidates = [
    meta?.[COMPANY_DOC_TYPE_KEY],
    meta?.docType,
    meta?.DocType,
    meta?.addressType,
    meta?.AddressType,
    meta?.incorporationType,
    meta?.ownershipType,
    meta?.natureOfBusinessType,
    meta?.sourceOfFundsType,
  ];
  const match = candidates.map((value) => String(value || '').trim()).find(Boolean);
  return match || '';
}
